import React from 'react';
import PropTypes from 'prop-types';
import ShowMoreText from 'react-show-more-text';

CustomShowMoreText.propTypes = {
	text: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.element,
		PropTypes.string,
	]),
	lines: PropTypes.number,
	iconChevronDown: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.element,
		PropTypes.string,
	]),
	iconChevronUp: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.element,
		PropTypes.string,
	]),
	expanded: PropTypes.bool,
};

CustomShowMoreText.defaultProps = {
	iconChevronDown: <span className="icon-chevron-down acc-font" />,
	iconChevronUp: <span className="icon-chevron-up acc-font" />,
	lines: 2,
	expanded: false,
};

export default function CustomShowMoreText({
	text,
	lines,
	iconChevronDown,
	iconChevronUp,
	expanded,
}) {
	return (
		<div className="custom-show-more-text">
			<ShowMoreText
				expanded={expanded}
				lines={lines}
				keepNewLines={false}
				more={iconChevronDown}
				less={iconChevronUp}>
				{text}
			</ShowMoreText>
		</div>
	);
}
